import { atom } from 'jotai';

import { createLoadAtom } from '../_graphql/mutationLoadCreate';
import { loadGetNextDocumentNumberAtom } from '../_graphql/mutationLoadGetNextDocumentNumber';
import { salesOrderLineItemsListAtom } from '../_graphql/querySalesOrderLineItemsList';
import { LoadFormState } from '../types/load';
import { initialState } from '../utils/loadCreate';

// 🔘🔘🔘 PLAIN ATOMS
export const $loadCreateForm = atom<LoadFormState>(initialState());
export const $loadCreateSalesOrderId = atom<string | undefined>(undefined);

// 🟢🟢🟢 REMOTE DATA -> sales order line items
export const $remoteLoadCreateSalesOrderLineItems = salesOrderLineItemsListAtom(
  (get) => ({
    variables: { salesOrderId: get($loadCreateSalesOrderId) ?? '' },
    skip: !get($loadCreateSalesOrderId),
  }),
);

// 🟢🟢🟢 DERIVED ATOM -> loading state for line items
export const $loadCreateLineItemsLoading = atom((get) => {
  const query = get($remoteLoadCreateSalesOrderLineItems);
  return query.isLoading;
});

// 🟠🟠🟠 ACTION -> RESET load create form
export const $resetLoadCreateForm = atom(null, (get, set) => {
  set($loadCreateForm, initialState());
});

// 🟠🟠🟠 ACTION -> NEXT DOCUMENT NUMBER
export const $nextLoadDocumentNumber = loadGetNextDocumentNumberAtom();

// 🟠🟠🟠 ACTION -> CREATE load
export const $createLoad = createLoadAtom();
